<style lang="scss">
body {
    background: white;
    height: 100%;
}
.dy_notice {
    .flex {
        display: flex;
    }

    background: white;
    .site_banner {
        background: url(../../assets/images/dy/all.png) #51b5c8 no-repeat center
            center;
        height: 300px;
        text-align: center;
        width: auto;
        background-position: 0 -1303px;
        line-height: 300px;
        img {
            vertical-align: middle;
        }
    }
    .content {
        width: 1170px;
        margin: 20px auto;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 20px 80px 70px 80px;
        background: white;
        border: 1px solid #f5f5f5;
        box-shadow: -3px 0 10px #ebebeb, 3px 0 10px #ebebeb, 0 -3px 10px #ebebeb,
            0 3px 10px #ebebeb;
        .annoucementForm-header {
            text-align: center;
            font-size: 22px;
            font-weight: 600;
            padding: 10px 0;
        }
    }
}
</style>

<template>
    <div class="dy_notice">
        <div class="site_banner">
            <img src="../../assets/images/dy/logo.png">
        </div>
        <div class="content">
            <div class="annoucementForm-box">
                <div class="annoucementForm-header">
                    <span class="text">{{noticeInfo.title}}</span>
                </div>
                <div class="detail" v-html="noticeInfo.content">
                </div>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    data: function() {
        return {
            noticeInfo:{
                title:"",
                content:""
            }
        };
    },
    created: function() {
        this.getAnnouncement(this.$route.query.id);
    },
    methods: {
        getAnnouncement(notice_id) {
            this.$http
                .get(globalProvider.serviceUrl("ea/g/nts/d/{notice_id}"), {
                    params: {
                        notice_id: notice_id
                    }
                })
                .then(data => {
                    if (data.body.code == resultCode.Success) {
                        this.noticeInfo = data.body.data;
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(
                            getErrorMessage(data.body.message),
                            "提示",
                            {
                                confirmButtonText: "确定"
                            }
                        );
                    }
                });
        }
    }
};
</script>


